import { render } from "./EmailESign.vue?vue&type=template&id=0bc61984&scoped=true&ts=true"
import script from "./EmailESign.vue?vue&type=script&lang=ts"
export * from "./EmailESign.vue?vue&type=script&lang=ts"

import "./EmailESign.vue?vue&type=style&index=0&id=0bc61984&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc61984"]])

export default __exports__